export default "__VITE_ASSET__CUjEsz7d__"